import { render, staticRenderFns } from "./OrganismHomeLanding.vue?vue&type=template&id=4026a15a&"
import script from "./OrganismHomeLanding.vue?vue&type=script&lang=js&"
export * from "./OrganismHomeLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports